import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import { cookie } from '@ifeng-fe/ui_base';
import LazyLoad from '@ifeng-fe/ui_pc_lazyLoad';
import Ad from '@ifeng-fe/ui_pc_ad';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { InformationFlow, Comment } from 'ThreeTerminal_mobile_dynamic';
import Caption from './caption';
import MainContent from './mainContent';
import HotNews from './hotNews';
import Share from './share';
import { handleCallNewsApp, h5PageCount } from 'ThreeTerminal_utils';
import CutOff from './cutOff';

const isBig = typeof document !== 'undefined' && cookie.get('isBigFont') === 'true';

class Article extends React.PureComponent {
    static propTypes = {
        docData: PropTypes.object,
        comment: PropTypes.object,
        hotNews: PropTypes.array,
        recommendArticles: PropTypes.array,
        ad: PropTypes.object,
        sharePPX: PropTypes.string,
        unfoldType: PropTypes.string,
        articleUnfoldLayer: PropTypes.object,
        isHitBlack: PropTypes.bool,
        hasCopyRight: PropTypes.bool,
        interact: PropTypes.object,
        sourceReason: PropTypes.string,
        textListAd: PropTypes.object,
        cutoffGray: PropTypes.object,
        createTime: PropTypes.string,
    };

    state = {
        isBig,
        isShowCutOff: false,
    };

    handleChangeFontSize = (isBig) => {
        cookie.set('isBigFont', isBig);

        this.setState({
            isBig,
        });
    };

    handleClick = () => {
        const { docData } = this.props;
        const aid = `ucms_${docData.base62Id}`;
        const share = `//m.ifeng.com/shareNews?ch=qd_sdk_dl1&aid=${aid}`;
        const downloads = {
            download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1429035725136',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=2905',
        };

        h5PageCount([
            {
                behavior: 'action',
                type: 'openapp_more',
                other: {
                    id: `ucms_${docData.base62Id}`,
                    ref: encodeURIComponent(document.referrer),
                    url: encodeURIComponent(location.href),
                },
            },
        ]);

        handleCallNewsApp('', 'doc', aid, share, 0, 0, 'in_sf01', {}, downloads);
    };

    showCutOffHandle = () => {
        this.setState({
            isShowCutOff: true,
        });
    };

    isCutoffHandle = () => {
        const {
            docData: { wemediaEAccountId },
            cutoffGray,
        } = this.props;

        if (cutoffGray?.cutoffIds?.length > 0) {
            cutoffGray.cutoffIds = cutoffGray.cutoffIds.filter((item) => item.isClose === false) || [];
        }
        const cutoffGrayIds = cutoffGray?.cutoffIds?.map?.((item) => item.id) || [];
        const startTime = new Date(cutoffGray?.startTime).getTime();
        const endTime = new Date(cutoffGray?.endTime).getTime();
        const nowTime = new Date().getTime();
        let isTimeout = false;

        if (nowTime < startTime || nowTime > endTime) {
            isTimeout = true;
        }

        return cutoffGrayIds.includes(wemediaEAccountId) && cutoffGray?.percentage && !isTimeout;
    };

    render() {
        const { isBig, isShowCutOff } = this.state;
        const {
            docData,
            docData: {
                isArea,
                noffhFlag,
                title,
                source,
                sourceUrl,
                newsTime,
                contentData,
                fhhAccountDetail,
                editorName,
                editorCode,
                imagesInContent,
                videosPluginData,
                slidesPluginData,
                surveyPluginData,
                goodsPlugin,
                type,
                searchPath,
                base62Id,
                subscribe,
                wemediaEAccountId,
                filterMediaList,
                isOriginal,
            },
            comment: { noAd, commentUrl, skey, pcUrl },
            hotNews,
            recommendArticles,
            ad: { topAd, infoAd0, infoAd1, infoAd2, bannerAd, articleBottomAd },
            sharePPX,
            unfoldType,
            articleUnfoldLayer,
            isHitBlack,
            hasCopyRight,
            interact,
            sourceReason,
            textListAd,
            cutoffGray,
            createTime,
        } = this.props;

        const pluginData = {
            videosPluginData,
            slidesPluginData,
            surveyPluginData,
            goodsPlugin,
        };

        const captionData = {
            title,
            source,
            sourceUrl,
            newsTime,
            fhhAccountDetail,
            noffhFlag,
            hasCopyRight,
            base62Id,
            subscribe,
        };
        const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';
        
        const commentConfig = {
            noAd,
            // 文章单页的页面地址
            docUrl: commentUrl,
            // 文章的标题
            docTitle: title,
            // 文章评论的skey，这个是在后端生成好后给到前端的
            skey,
            // 兼容以后的专题评论
            speUrl: '',
            // 文章pc的页面地址
            pcUrl,
            // 获取评论内容接口
            cmtNumUrl: `//${ commentDomain }/get.php`,
            // 评论内容字数长度
            cmtLength: 1000,
            // 提交评论内容接口
            cmtPostUrl: `//${ commentDomain }/post.php`,
            // 最热评论数量
            hotLimit: 2,
            // 推荐评论接口
            cmtVoteUrl: `//${ commentDomain }/vote.php`,
            // 现实回复的楼层
            replyLimit: 3,
            // 举报提交接口
            jubUrl: `//${ commentDomain }/report`,
            // 举报次数，便于每次回调函数名不同
            jubNum: 0,
            // 是否是评论详情页面
            isComment: false,
        };
        const isShowEditName = editorCode && (hasCopyRight || sourceReason === '公开信息');

        // if (recommendArticles.length > 0) {
        //     recommendArticles.forEach(item => {
        //         item.callUp = 1;
        //         item.newstype = item.type === 'article' ? 'doc' : item.type;
        //         item.kind = 'in_sf01';
        //         item.downloads = {
        //             download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1429035767411',
        //             downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=2905',
        //         };
        //         item.clickCount = {
        //             behavior: 'action',
        //             type: 'openapp_com',
        //             other: {
        //                 ref: `ucms_${item.base62Id}`,
        //                 to: true,
        //                 kind: 'article',
        //                 url: encodeURIComponent(location.href),
        //                 plat: 'napp',
        //                 downurl: encodeURIComponent(
        //                     'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1348580715362',
        //                 ),
        //             },
        //         };
        //     });
        // }

        const cutofffConfig = {
            type,
            createTime,
            base62Id,
            title,
            isCutoff: this.isCutoffHandle(),
            cutoffGray: cutoffGray?.percentage || 0,
            isPCCallQuickapp: cutoffGray?.isPCCallQuickapp || '1',
            isMobileCallQuickapp: cutoffGray?.isMobileCallQuickapp || '1',
            cutoffIds: cutoffGray?.cutoffIds,
            filterUA: cutoffGray?.filterUA,
            wemediaEAccountId,
            isHitBlack,
        };

        return (
            <div className={styles.content}>
                {!isArea && <Ad content={topAd} />}
                {!isShowCutOff && (
                    <Caption
                        content={captionData}
                        isBig={isBig}
                        handleChangeFontSize={this.handleChangeFontSize}
                        pageType={type}
                    />
                )}
                {contentData.contentList && !isShowCutOff ? (
                    <MainContent
                        imagesInContent={imagesInContent}
                        content={contentData}
                        pluginData={pluginData}
                        isBig={isBig}
                        unfoldType={unfoldType}
                        articleUnfoldLayer={articleUnfoldLayer}
                        base62Id={docData.base62Id}
                        pageType={type}
                        searchPath={searchPath}
                        hasCopyRight={hasCopyRight}
                        isHitBlack={isHitBlack}
                        textListAd={textListAd}
                        cutofffConfig={cutofffConfig}
                        wemediaEAccountId={wemediaEAccountId}
                        filterMediaList={filterMediaList}
                        isOriginal={isOriginal}
                        interact={interact}
                    />
                ) : (
                    ''
                )}
                <CutOff
                    cutofffConfig={cutofffConfig}
                    isShowCutOff={isShowCutOff}
                    showCutOffHandle={this.showCutOffHandle}
                />
                <div className={styles.editor_box}>
                    {isArea ? (
                        <span className={styles.editor}>{isShowEditName ? `责任编辑：${editorName}` : ''}</span>
                    ) : (
                        <span className={styles.editor}>
                            {isShowEditName ? `责任编辑：${editorName} ${editorCode}` : ''}
                        </span>
                    )}
                    <span className={styles.jubao}>
                        <a href="//news.ifeng.com/ask/index.shtml" target="_blank">
                            举报
                        </a>
                    </span>
                </div>
                {!isHitBlack && <div id="articleEnd" />}
                <div className={styles.br} />
                {!isHitBlack && <Ad content={articleBottomAd} />}
                <div className={styles.link}>
                    <a onClick={this.handleClick}>打开 app 阅读更多精彩内容</a>
                </div>
                {!isHitBlack && <HotNews content={hotNews} />}
                {!isHitBlack && (
                    <NoSSR>
                        <Ad content={infoAd0} styleName={styles.ad_box} />
                        {!interact?.isCloseShare && <Share docData={docData} sharePPX={sharePPX} />}
                        <Ad content={infoAd1} styleName={styles.ad_box} />
                    </NoSSR>
                )}
                {recommendArticles.length > 0 ? (
                    <InformationFlow isDisplayLoadingMore={false} content={recommendArticles} />
                ) : (
                    ''
                )}
                <div className={styles.comment_box} ref={this.container}>
                    <NoSSR>
                        <Ad content={infoAd2} styleName={styles.ad_box1} />
                    </NoSSR>
                    <div className={styles.comment}>
                        <LazyLoad>
                            <Comment articleInfo={commentConfig} />
                        </LazyLoad>
                    </div>
                    <NoSSR>
                        <Ad content={bannerAd} styleName={styles.ad_box} />
                    </NoSSR>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Article);
